import { Injectable, Injector } from "@angular/core";
import { AppContext, DataPropInfo, Entity, FrameContext, Repository } from "@farris/devkit";
import { BindingPathService } from "./binding-path.service";
import { FormControlService } from './form-control.service';

@Injectable()
export class FrameContextService {
  constructor(
    private injector: Injector, 
    private appContext: AppContext, 
    private frameContext: FrameContext, 
    private repository: Repository<Entity>,
    private bindingPathService: BindingPathService,
    private formControlService: FormControlService
    ) { }
  /**
     * éè¿BEè¡¨åè·åå¯¹åºçframeContext
     * @param tableName 
     * @returns 
     */
  public getFrameContextsByTableName(tableName: string): null | FrameContext[] {
    if (!tableName) {
      throw new Error('tableName ä¸è½ä¸ºç©ºã');
    }
    const dataTypeInfo = this.repository && this.repository.entityTypeInfo || null;
    if (!dataTypeInfo) {
      return null;
    }
    const bindingPaths = [];
    this.bindingPathService.getBindingPathsByTableName(dataTypeInfo, tableName, bindingPaths);
    const frameContexts = this.appContext && this.appContext.frameContextManager.getFrameContexts() || [];
    if (!frameContexts || frameContexts.length === 0) {
      return null;
    }
    return frameContexts.filter((frameContext: FrameContext) => frameContext && frameContext.viewModel && frameContext.viewModel.bindingPath.split('/').filter(p => p).join('/') === bindingPaths.join('/'));
  }
  /**
   * æ ¹æ®å­æ®µå®æ´è·¯å¾è·åæå¨çä¸ä¸æ
   * @param propertyPath 
   * @param separtor 
   * @returns 
   */
  public getFrameContextsByPropertyPath(propertyPath: string, separtor: string = '/'): FrameContext[] {
    if (!propertyPath) {
      throw new Error('propertyPath ä¸è½ä¸ºç©ºã');
    }
    const frameContexts = this.appContext && this.appContext.frameContextManager.getFrameContexts() || [];
    return frameContexts.filter((frameContext: FrameContext) => {
      const formControls = frameContext && frameContext.form && frameContext.form.ngFormControls || {};
      const bindingPath = frameContext && frameContext.viewModel && frameContext.viewModel.bindingPath || '';
      if (formControls && Object.keys(formControls).length > 0) {
        const key = Object.keys(formControls).find((key: string) => {
          const formControl = formControls[key];
          if (!formControl || !formControl.binding) {
            return false;
          }
          const bindings = formControl.binding.split('.').filter(p => p);
          const bindingPaths = bindingPath.split('/').filter(p => p);
          const fullPath = bindingPaths.concat(bindings);
          return propertyPath.split(separtor).filter(p => p).join('/') === fullPath.join('/');
        });
        return key ? true : false;
      }
      return false;
    });
  }
  /**
   * éè¿BEå­æ®µåè·åå­æ®µçbindingPath
   * @param bindingPaths ç»å®è·¯å¾
   * @param columnName BEå­æ®µå
   * @returns 
   */
  public getFrameContextsByColumnName(bindingPaths: string[], columnName: string): FrameContext[] | null {
    if (!bindingPaths) {
      throw new Error('bindingPath ä¸è½ä¸ºç©ºã');
    }
    if (!columnName) {
      throw new Error('columnName ä¸è½ä¸ºç©ºã');
    }
    bindingPaths = bindingPaths.filter(p => p);
    const entityTypeInfo = this.repository && this.repository.entityTypeInfo || null;
    if (!entityTypeInfo) {
      return null;
    }
    const dataTypeInfo = entityTypeInfo.getTypeInfoByPath(bindingPaths);
    const dataPropInfos = dataTypeInfo && dataTypeInfo.getPropInfos() || [];
    const columnPropInfo = dataPropInfos.find((dataPropInfo: DataPropInfo) => dataPropInfo.metadataInfo && (dataPropInfo.metadataInfo.originalDataField === columnName || dataPropInfo.metadataInfo.dataField === columnName));
    if (!columnPropInfo || !columnPropInfo.metadataInfo) {
      return null;
    }
    const frameContexts = this.appContext.frameContextManager.getFrameContexts();
    return frameContexts.filter((frameContext: FrameContext) => {
      const ngFormControls = this.formControlService.getFormControlsByFrameContext(frameContext);
      if (!ngFormControls || Object.keys(ngFormControls).length < 1) {
        return false;
      }
      const currentBindingPaths = this.bindingPathService.getBindingPathsByFrameContext(frameContext) || [];
      const isValidFrameContext = currentBindingPaths.join('/') === bindingPaths.join('/');
      if (!isValidFrameContext) {
        return false;
      }
      const ngFormControl = Object.values(frameContext.viewModel.form.ngFormControls).find(item => item.binding === columnPropInfo.metadataInfo.path);
      return ngFormControl ? true : false;
    });
  }
  
  /**
   * éè¿ç»å®è·¯å¾è·åå¯¹åºçç»ä»¶ä¸ä¸ææ°ç»
   * @param bindingPath bindingPathå­ç¬¦ä¸²
   * @param namespace ns,é»è®¤ä¸º''
   */
   public getFrameContextsByBindingPath(bindingPath: string | string[], namespace: string = ''): FrameContext[] {
    if (Array.isArray(bindingPath)) {
      bindingPath = bindingPath.join('/');
    }
    const frameContexts = this.appContext && this.appContext.frameContextManager.getFrameContexts() || [];
    return frameContexts.filter((frameContext: FrameContext) => frameContext && frameContext.namespace === namespace && frameContext.viewModel.bindingPath === bindingPath);
  }
}